import React, { useState, useEffect } from 'react'
import EmployerDashBoardSidebar from '../../employerDashboard/sidebar'

const DashboardNavigation = ({
  location,
  showDropdownOnMobile,
  toggleBlur,
  user,
}) => {
  const [sidebarOpenOrClose, setSidebarOpenOrClose] = useState(false)

  useEffect(() => {
    showDropdownOnMobile.current = toggleMobileMenu
  }, [sidebarOpenOrClose])

  function toggleMobileMenu() {
    toggleBlur()
    setSidebarOpenOrClose(!sidebarOpenOrClose)
  }

  return (
    <>
      <div
        className={`${
          sidebarOpenOrClose ? 'shown' : 'hidden'
        } sidebar-dashboard visible md:invisible`}
      >
        <div className="w-full flex justify-end relative">
          <button
            className="text-white text-xl absolute right-6 top-6"
            onClick={() => toggleMobileMenu()}
          >
            X
          </button>
        </div>
        <div>
          <EmployerDashBoardSidebar location={location} isDropdown={true} />
        </div>
      </div>
    </>
  )
}
export default DashboardNavigation
